module.exports = __webpack_public_path__ + "img/rosario_summer.5709bab8.svg";